export enum SubscriptionInterval {
  Month = 'month',
}
